import axios from '@/libs/http'


export const getOrderComplainList = (userId, clerkId, orderNo, isShow, userWechatId, createdStart, createdEnd, pageNo, pageSize) => {
  return axios.request({
    url: '/s/l/orderComplain/list',
    params: {
      userId, clerkId, orderNo, isShow, userWechatId, createdStart, createdEnd, pageNo, pageSize
    },
    method: 'get'
  })
}
export const getComplain = (complainId) => {
  return axios.request({
    url: '/s/l/orderComplain/getComplain',
    params: {
      complainId
    },
    method: 'get'
  })
}


